module.exports = __webpack_public_path__ + "img/27.d4626434.webp";